<template>
  <fragment>
    <tr>
      <th>
        받는 사람
        <span v-if="required" class="required">*</span>
      </th>
      <td>
        <input type="radio" :id="`group_${uuid}`" :name="`group_${uuid}`" value="Y" v-model="rcpGroupSendYn_local" />
        <label :for="`group_${uuid}`">그룹전송</label>
        <input type="radio" :id="`target_${uuid}`" :name="`group_${uuid}`" value="N" v-model="rcpGroupSendYn_local" />
        <label :for="`target_${uuid}`">대상자별 전송</label>
      </td>
    </tr>
    <tr>
      <th>
        그룹 선택
        <span v-if="required" class="required">*</span>
      </th>
      <td>
        <div class="group_selector">
          <GroupSelector permissionCode="register" ref="groupSelector" />
          <template v-if="rcpGroupSendYn_local == 'N'">
            <button type="button" class="btn_search" @click="onClickFindRecipient">검색</button>
            <SelectedRcp
              v-if="selectedRcpList_local && selectedRcpList_local.length"
              :rcpList="selectedRcpList_local"
              @delete="deleteSelectedRcp"
            />
            <p v-else class="group_selector_desc">대상을 선택해 주세요.</p>
          </template>
        </div>
      </td>
    </tr>
  </fragment>
</template>

<script>
import newsMixin from '$views/News/_mixin';
import SelectedRcp from './TargetSelector.selectedRcp';

export default {
  components: {SelectedRcp},
  mixins: [newsMixin],
  props: {
    rcpGroupSendYn: {
      type: String,
      default: 'Y',
    },
    selectedRcpList: {
      type: Array,
      default: () => [],
    },
    required: Boolean,
  },
  data() {
    return {
      rcpGroupSendYn_local: this.rcpGroupSendYn,
      selectedRcpList_local: this.selectedRcpList,
    };
  },
  watch: {
    rcpGroupSendYn_local(val) {
      this.$emit('update:rcpGroupSendYn', val);
    },
    selectedRcpList_local(val) {
      this.$emit('update:selectedRcpList', val);
    },
  },
  methods: {
    onClickFindRecipient() {
      const initGroup = this.$refs.groupSelector.getData();
      if (!initGroup.orgId || !initGroup.stateId) {
        alert('찾으려는 사람의 대상 지자체를 선택해 주세요.');
        return;
      }
      this.openRecipientSelector({
        initGroup,
        onSelected: this.onSelectedRcp,
        opener: this,
      });
    },
    onSelectedRcp(rcpList) {
      _.forEach(rcpList, (item) => {
        const idx = _.findIndex(this.selectedRcpList_local, (selectedItem) => selectedItem.recipientId === item.recipientId);
        if (idx < 0) this.selectedRcpList_local.push(item);
        else console.log('이미 등록되어 있는 대상자입니다.', item.recipientId);
      });
    },
    deleteSelectedRcp(rcpItem) {
      this.$delete(this.selectedRcpList_local, _.findIndex(this.selectedRcpList_local, rcpItem));
    },
    getGroupData() {
      return this.$refs.groupSelector.getData();
    },
    getGroupFullData() {
      return this.$refs.groupSelector.getFullData();
    },
    validate() {
      if (!this.required) return true;

      switch (this.rcpGroupSendYn) {
        case 'N':
          if (_.isEmpty(this.selectedRcpList)) {
            alert('소식 받을 그룹이나 사람을 지정해 주세요.');
            return false;
          }
          break;
        case 'Y':
          const initGroup = this.getGroupData();
          if (!initGroup.orgId || !initGroup.stateId) {
            alert('소식 받을 그룹이나 사람을 지정해 주세요.');
            return false;
          }
          break;
      }
      return true;
    },
  },
};
</script>
